import { Link } from "react-router-dom";
import { IInvoice } from "../@types";
import {
  getRecurringStatusClass,
  getRecurringStatusColor,
  getStatusClass,
  getStatusColor,
} from "../components/Sales/invoice/Status/status";
import { Statuses } from "../constants";
import { getInvoiceReoccur, getInvoiceStatus } from "./invoice";
import { formatMoney } from "./format";
import dayjs from "dayjs";

export const getDaySuffix = (day: number) => {
  if (day >= 11 && day <= 13) {
    return day + "th";
  }

  switch (day % 10) {
    case 1:
      return day + "st";
    case 2:
      return day + "nd";
    case 3:
      return day + "rd";
    default:
      return day + "th";
  }
};

export const columns = [
  {
    key: "invoiceNumbers",
    label: "Invoice",
    className: "",
    width: 8,
  },
  {
    key: "customer",
    label: "Customer Name",
    className: "",
    width: 26,
  },
  {
    key: "issueDate",
    label: "Issue Date",
    className: "",
    width: 15,
  },
  {
    key: "reoccurringStatus",
    label: "Status",
    className: "",
    width: 21,
  },
  {
    key: "inventories",
    label: "Balance Due",
    className: "",
    width: 15,
  },
];

const tags: any = {
  paid: {
    text: "#039855",
    bg: "#ECFDF3",
  },
  active: {
    text: "#039855",
    bg: "#ECFDF3",
  },
  expired: {
    text: "#D92D20",
    bg: "#FEF3F2",
  },
  pending: {
    text: "#DC6803",
    bg: "#FFFAEB",
  },
  due: {
    text: "#D92D20",
    bg: "#FEF3F2",
  },
  paused: {
    text: "#DC6803",
    bg: "#FFFAEB",
  },
  draft: {
    text: "#03B8DC",
    bg: "#EBFCFF",
  },
  cancelled: {
    text: "#475467",
    bg: "#F9FAFB",
  },
  refunded: {
    text: "#044E97",
    bg: "#E0EEFE",
  },
};

export const renderInvoicesData = (
  invoices: IInvoice[],
  isReoccurring: boolean | null,
) => {
  return invoices
    .filter((invoice: IInvoice) => {
      if (isReoccurring !== null && invoice.isReoccurring !== isReoccurring) {
        return false;
      }
      return true;
    })
    .map((invoice: IInvoice, index) => {
      const statusCapitalized = invoice.reoccurringStatus
        ? invoice.reoccurringStatus.charAt(0).toUpperCase() +
          invoice.reoccurringStatus.slice(1)
        : "";

      const isDraft = statusCapitalized === Statuses.DRAFT;
      const linkTo = isDraft
        ? `/invoices/${invoice.id}`
        : `/invoices/${invoice.id}/recurringView`;
      const linkText = isDraft ? invoice.invoiceNumber : invoice.invoiceNumber;
      const statusClass = getRecurringStatusClass(statusCapitalized);
      const statusColor = getRecurringStatusColor(statusCapitalized);
      const invoiceId = invoice.id;

      return {
        invoiceNumbers: (
          <Link className="text-violet-800" to={linkTo}>
            {linkText}
          </Link>
        ),
        customer: (
          <Link
            className="xl:text-violet-800"
            to={`/customers/${invoice?.customer?.id}/view`}
          >
            {invoice.customer.businessName ??
              `${invoice?.customer?.firstName} ${invoice?.customer?.lastName}`}
          </Link>
        ),
        issueDate: `${dayjs(invoice.issueDate).format("MMM")} ${getDaySuffix(
          dayjs(invoice.issueDate).date(),
        )} ${dayjs(invoice.issueDate).format("YYYY")}`,
        invoiceNumber: invoice.invoiceNumber,
        reoccurringStatus: (
          <div className="flex justify-start">
            <div
              className={` px-1.5  py-1 border border-[${tags[invoice.reoccurringStatus!]?.text}] rounded-[4px] text-[13px] font-medium capitalize bg-[${tags[invoice.reoccurringStatus!]?.bg}] text-[${tags[invoice.reoccurringStatus!]?.text}]`}
            >
              {statusCapitalized}
            </div>
          </div>
        ),
        isReoccurring: invoice.reoccurringGroupName,
        inventories: formatMoney(invoice.balanceDue, invoice.currency),
        invoiceId: invoiceId,
      };
    });
};
